import { render, staticRenderFns } from "./sysmenu.vue?vue&type=template&id=7b4d20c3&scoped=true"
import script from "./sysmenu.vue?vue&type=script&lang=js"
export * from "./sysmenu.vue?vue&type=script&lang=js"
import style0 from "./sysmenu.vue?vue&type=style&index=0&id=7b4d20c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d20c3",
  null
  
)

export default component.exports